// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import './styles/index.css';
import store from './store';
import Counter from './pages/details/components/Counter';
export default Counter;

Vue.config.productionTip = false
// Vue.use(axios)
Vue.prototype.axios = axios
axios.defaults.baseURL = 'https://saas-dev.wolaidai.com/'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['x-user-token'] = 'bachvgflpbpbs6384571799501721607';

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
import 'swiper/dist/css/swiper.css'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js